// extracted by mini-css-extract-plugin
export default {"form":"NewMonsterForm_form__+ozMK"};